import { ReactComponent as SvgBoatlaunch } from "../../assets/images/icons/boatlaunch.svg"
import { ReactComponent as SvgAccomodation } from "../../assets/images/icons/accomodation.svg"
import { ReactComponent as SvgFishing } from "../../assets/images/icons/fishing.svg"
import { ReactComponent as SvgFishingarea } from "../../assets/images/icons/fishingarea.svg"
import { ReactComponent as SvgShop } from "../../assets/images/icons/shop.svg"
import { ReactComponent as SvgRental } from "../../assets/images/icons/rental.svg"

const icons = {
  // by featured category name
  boatlaunch: SvgBoatlaunch,
  accommodation: SvgAccomodation,
  fishing: SvgFishing,
  fishingwater: SvgFishingarea,
  shop: SvgShop,
  rental: SvgRental,
  // by category id
  118: SvgBoatlaunch,
  55: SvgAccomodation,
  26: SvgFishing,
  229: SvgFishingarea,
  73: SvgShop,
  76: SvgShop,
  74: SvgRental,
}

export default function CategorySvg({ name, ...props }) {
  if (!name || !icons[name]) return null

  return icons[name](props)
}
